import {
  BLOCKED_USERS_GET_URL,
  MY_PROFILE_PASSWORD_SETTINGS,
  MY_PROFILE_PUSH_SETTINGS,
  MY_PROFILE_SOUND_SETTINGS,
  UNSUBSCRIBE_IS_ACTIVE_USER_URL,
  UNSUBSCRIBE_USER_URL,
  USER_DISABLE_PROFILE,
  VERIFICATION_FILES_DATA_GET_URL,
} from "shared/constants/apiUrls";

import { get, post } from "./axios";

/**
 * Get list of blocked users
 * @param {null|number} page
 * @param {null|number} limit
 */

export const getBlockedUsers = (limit = null, page = null) => {
  let query = limit ? "?limit=" + limit : "";
  query += page ? (limit ? "&" : "?") + "page=" + page : "";
  return get(import.meta.env.VITE_APP_API_HOST + BLOCKED_USERS_GET_URL + query);
};

/**
 * Get status of Verification user
 */
export const getVerificationUser = () => {
  return get(
    import.meta.env.VITE_APP_API_HOST + VERIFICATION_FILES_DATA_GET_URL
  );
};

/**
 * Update profile password
 * @param data
 */
export const updatePasswordSettings = (data) => {
  return post(
    import.meta.env.VITE_APP_API_HOST + MY_PROFILE_PASSWORD_SETTINGS,
    data
  );
};
/**
 * Disable profile
 * @param data
 */
export const disableUserProfile = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + USER_DISABLE_PROFILE, data);
};

/**
 * Update profile sound settings
 * @param data
 */
export const updateSoundSettings = (data) => {
  return post(
    import.meta.env.VITE_APP_API_HOST + MY_PROFILE_SOUND_SETTINGS,
    data
  );
};

/**
 * Update profile notifications settings
 * @param data
 */
export const updateNotificationsSettings = (data) => {
  return post(
    import.meta.env.VITE_APP_API_HOST + MY_PROFILE_PUSH_SETTINGS,
    data
  );
};

/**
 * Unsubscribe user
 * @param data
 */
export const unsubscribeUser = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + UNSUBSCRIBE_USER_URL, data);
};

/**
 * Сheck if the user who is trying to unsubscribe is active
 * @param params
 */
export const isActiveUser = (params) => {
  return get(
    import.meta.env.VITE_APP_API_HOST + UNSUBSCRIBE_IS_ACTIVE_USER_URL,
    {
      params,
    }
  );
};
